import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { isNil, sortBy } from 'lodash-es';

export function filterNil() {
  return function<T>(source: Observable<T>) {
    return source.pipe(filter(value => !isNil(value)));
  }
}

export function debug(tag = 'DEBUG') {
  return tap({
    next(value) {
      console.log(`%c[${tag}: Next]`, "background: #009688; color: #fff; padding: 3px; font-size: 9px;", value)
    },
    error(error) {
      console.log(`%[${tag}: Error]`, "background: #E91E63; color: #fff; padding: 3px; font-size: 9px;", error)
    },
    complete() {
      console.log(`%c[${tag}]: Complete`, "background: #00BCD4; color: #fff; padding: 3px; font-size: 9px;")
    }
  })
}

export function sortByField<T>(fieldName: string) {
  return function<T>(source: Observable<T>) {
    return source.pipe(map(results => {
      if(Array.isArray(results)) {
        return sortCaseInsensitive(results, fieldName)
      } else {
        return results;
      }
    }));
  }
}

export function sortCaseInsensitive<T>(list: T[], field: string): T[] {
  const iteratee = item => { return typeof item[field] === 'string' && !isNil(item[field]) ? item[field].toLowerCase() : item[field]};
  return sortBy(list, [iteratee]);
}




